import { useContentGeneration } from './useContentGeneration';

/**
 * Custom hook for keyword generation functionality
 * Wraps useContentGeneration with keyword-specific naming
 */
export const useKeywordGeneration = () => {
  const baseHook = useContentGeneration('keyword', 'keywords');

  // Map generic names to keyword-specific names
  return {
    // State - map to keyword-specific names
    keywordYoutubeUrl: baseHook.youtubeUrl,
    youtubeVideoInfo: baseHook.youtubeVideoInfo,
    extractingVideoInfo: baseHook.extractingVideoInfo,
    generatedKeywords: baseHook.generatedContent,
    currentKeywordProjectId: baseHook.currentProjectId,
    generatingKeywords: baseHook.generatingContent,
    keywordPrompt: baseHook.prompt,
    keywordPromptVersion: baseHook.promptVersion,
    keywordPromptTotalVersions: baseHook.promptTotalVersions,
    selectedPromptId: baseHook.selectedPromptId,
    selectedPromptVersionForUse: baseHook.selectedPromptVersionForUse,
    isEditingKeywordPrompt: baseHook.isEditingPrompt,
    editedKeywordPrompt: baseHook.editedPrompt,
    keywordPromptLoading: baseHook.promptLoading,
    
    // Setters - map to keyword-specific names
    setKeywordYoutubeUrl: baseHook.setYoutubeUrl,
    setYoutubeVideoInfo: baseHook.setYoutubeVideoInfo,
    setExtractingVideoInfo: baseHook.setExtractingVideoInfo,
    setGeneratedKeywords: baseHook.setGeneratedContent,
    setCurrentKeywordProjectId: baseHook.setCurrentProjectId,
    setGeneratingKeywords: baseHook.setGeneratingContent,
    setKeywordPrompt: baseHook.setPrompt,
    setKeywordPromptVersion: baseHook.setPromptVersion,
    setKeywordPromptTotalVersions: baseHook.setPromptTotalVersions,
    setSelectedPromptId: baseHook.setSelectedPromptId,
    setSelectedPromptVersionForUse: baseHook.setSelectedPromptVersionForUse,
    setIsEditingKeywordPrompt: baseHook.setIsEditingPrompt,
    setEditedKeywordPrompt: baseHook.setEditedPrompt,
    setKeywordPromptLoading: baseHook.setPromptLoading,
    
    // Functions - map to keyword-specific names
    extractYoutubeVideoInfo: baseHook.extractYoutubeVideoInfo,
    generateKeywordsFromDescription: baseHook.generateContentFromDescription,
    fetchKeywordPrompt: baseHook.fetchPrompt,
    fetchKeywordPromptVersion: baseHook.fetchPromptVersion,
    handleKeywordPromptVersionChange: baseHook.handlePromptVersionChange,
    clearKeywordState: baseHook.clearState,
    saveKeywordPrompt: baseHook.savePrompt,
  };
};
